import { forwardRef, useImperativeHandle, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import AuditLogsExportTemplate from "../templates/AuditLogsExportTemplate";

export interface AuditLogExportModalRef {
  show: () => void;
}

interface AuditLogExportModalProps {
  onConfirm: (dates: { date_from?: string; date_to?: string }) => void;
}

export const AuditLogExportModal = forwardRef<
  AuditLogExportModalRef,
  AuditLogExportModalProps
>(({ onConfirm }, ref) => {
  const [showing, setShowing] = useState(false);

  useImperativeHandle(ref, () => ({
    show: () => {
      setShowing(true);
    },
  }));

  const handleClose = () => {
    setShowing(false);
  };

  return (
    <ReusableModal
      isVisible={showing}
      onClose={handleClose}
      title="Export Audit Logs"
      className="w-full max-w-[600px] mx-auto"
      hasCancelButton
    >
      <AuditLogsExportTemplate onConfirm={onConfirm} onClose={handleClose} />
    </ReusableModal>
  );
});
AuditLogExportModal.displayName = "AuditLogExportModal";
export default AuditLogExportModal;
